import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';

const TemplateRowLoaderItem = () => (
  <ContentLoader width={285} height={50} viewBox="0 0 285 50">
    <rect x="0" y="17" rx="3" ry="3" width="120" height="6" />
    <rect x="0" y="30" rx="3" ry="3" width="180" height="6" />
  </ContentLoader>
);

const TemplateRowLoader = () => (
  <>
    <Flex
      data-testid="TemplateRowLoader"
      alignItems="center"
      height="60px"
      padding="8px 16px"
    >
      <TemplateRowLoaderItem />
    </Flex>
    <Flex alignItems="center" height="60px" padding="8px 16px">
      <TemplateRowLoaderItem />
    </Flex>
    <Flex alignItems="center" height="60px" padding="8px 16px">
      <TemplateRowLoaderItem />
    </Flex>
  </>
);

TemplateRowLoader.displayName = 'TemplateRowLoader';

export default TemplateRowLoader;
